module.exports = __webpack_public_path__ + "static/media/icomoon.632bdf05.svg";